import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaLeaf, FaPepperHot, FaSnowflake } from "react-icons/fa";
import { useCart } from "../context/CartContext";
import toast from "react-hot-toast";

import menuData from "../data/menuData";


const { categories, foodItems, getBannerImage } = menuData;


const Menu = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const { addToCart } = useCart(); 

  const filteredItems =
    selectedCategory === "All"
      ? foodItems
      : foodItems.filter((item) => item.category === selectedCategory);

  return (
    <motion.div
      className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Banner */}
      <div className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
        <img
          src={getBannerImage(selectedCategory)}
          alt="Menu Banner"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
          <h2 className="text-white text-4xl font-bold capitalize">
            {selectedCategory}
          </h2>
        </div>
      </div>

      {/* Category Tabs */}
      <div className="flex justify-center flex-wrap gap-4 mt-8">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 shadow-sm border 
              ${
                selectedCategory === cat
                  ? "bg-black text-white border-black"
                  : "bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600"
              }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Food Items */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-6 py-12 max-w-7xl mx-auto">
        {filteredItems.map((item) => (
          <motion.div
            key={item.id}
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.3 }}
            className="bg-white dark:bg-gray-800 shadow-xl rounded-2xl overflow-hidden flex flex-col"
          >
            <img
              src={item.image}
              alt={item.name}
              className="w-full h-56 object-cover object-center"
            />
            <div className="p-6 flex flex-col justify-between flex-grow">
              <div>
                <h3 className="text-xl font-bold mb-2 font-serif text-amber-700 dark:text-amber-400">
                  {item.name}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
                  {item.description}
                </p>

                <div className="flex gap-2 mb-4">
                  {item.tags.includes("vegan") && <FaLeaf title="Vegan" className="text-green-600" />} 
                  {item.tags.includes("hot") && <FaPepperHot title="Hot" className="text-red-500" />} 
                  {item.tags.includes("cold") && <FaSnowflake title="Cold" className="text-blue-400" />} 
                </div>
              </div>
              <div className="flex items-center justify-between mt-4">
                <span className="font-semibold text-lg">₹{item.price}</span>
                <button
  onClick={() => {
    addToCart(item);
    toast.success(`${item.name} added to cart`);
  }}
  className="bg-amber-600 text-white px-4 py-2 rounded-full font-medium hover:bg-amber-700 transition"
>
  Order Now
</button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Menu;
